export const delayBatchEvent = {
  eventType: {
    auto_reply: "自動返信",
    reminder: "リマインダー",
    scheduled_sending: "時間指定送信",
  },
};
